import { BaseInputProps } from './inputTypes';
import { KeyboardEvent } from 'react';

export const fieldNameToFormName = (fieldName?: string, index?: number) =>
  `assets.${index ?? 0}.values${fieldName ? `.${fieldName}` : ''}`;

export const enterNextStep =
  (nextStep: BaseInputProps['nextStep'], blocked: boolean | undefined) =>
  (e: KeyboardEvent) => {
    const noModifierKeys = !e.shiftKey && !e.altKey && !e.ctrlKey;
    const enterKey = e.key === 'Enter';
    if (enterKey && noModifierKeys && !blocked && nextStep) {
      nextStep();
    }
  };
